const API = process.env.REACT_APP_API_URL;

function authHeaders(extra = {}) {
  return {
    Authorization: `Bearer ${localStorage.getItem("authToken")}`,
    ...extra,
  };
}

async function jsonOrThrow(res) {
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.message || "Request failed");
  return data;
}

export async function adminListWalletTransactions({ status, type, q, limit = 20, offset = 0 }) {
  const params = new URLSearchParams();
  if (status) params.set("status", status);
  if (type) params.set("type", type);
  if (q) params.set("q", q);
  params.set("limit", String(limit));
  params.set("offset", String(offset));

  const res = await fetch(`${API}/api/admin/wallet/transactions?${params.toString()}`, {
    headers: authHeaders(),
  });
  return jsonOrThrow(res);
}

export async function adminApproveWalletTransaction(reference) {
  const res = await fetch(`${API}/api/admin/wallet/transactions/${encodeURIComponent(reference)}/approve`, {
    method: "POST",
    headers: authHeaders({ "Content-Type": "application/json" }),
    body: JSON.stringify({}),
  });
  return jsonOrThrow(res);
}

export async function adminRejectWalletTransaction(reference, reason = "") {
  const res = await fetch(`${API}/api/admin/wallet/transactions/${encodeURIComponent(reference)}/reject`, {
    method: "POST",
    headers: authHeaders({ "Content-Type": "application/json" }),
    body: JSON.stringify({ reason }),
  });
  return jsonOrThrow(res);
}


export async function adminListWalletTransfers({ status, q, limit = 20, offset = 0 }) {
  const params = new URLSearchParams();
  if (status) params.set("status", status);
  if (q) params.set("q", q);
  params.set("limit", String(limit));
  params.set("offset", String(offset));

  const res = await fetch(`${API}/api/admin/wallet/transfers?${params.toString()}`, {
    headers: authHeaders(),
  });
  return jsonOrThrow(res);
}

export async function adminApproveWalletTransfer(reference) {
  const res = await fetch(`${API}/api/admin/wallet/transfers/${encodeURIComponent(reference)}/approve`, {
    method: "POST",
    headers: authHeaders({ "Content-Type": "application/json" }),
    body: JSON.stringify({}),
  });
  return jsonOrThrow(res);
}

export async function adminRejectWalletTransfer(reference, reason = "") {
  const res = await fetch(`${API}/api/admin/wallet/transfers/${encodeURIComponent(reference)}/reject`, {
    method: "POST",
    headers: authHeaders({ "Content-Type": "application/json" }),
    body: JSON.stringify({ reason }),
  });
  return jsonOrThrow(res);
}

